module.exports = __webpack_public_path__ + "fonts/payback_light-webfont.7800480d.woff";